import _ from 'lodash'
import { Inject, Injectable } from '@angular/core'
import { GeneralMapLayerDefinitionsDtsrcLpisService } from './general-map-layer-definitions-dtsrc-lpis.service'
import { MapColorGeneratorService } from '../../../../../features/map/services/map-color-generator.service'
import { GeneralMapLayerDefinitionsConcernedService } from './general-map-layer-definitions-concerned.service'
import { GeneralMapLayerDefinitionsParcelGroupService } from './general-map-layer-definitions-parcel-group.service'
import { SelectedDepartmentService } from '../../../../../core/services/selected-department.service'
import { DepartmentMapFilterService } from './department-map-filter.service'
import { IFilterDefTypeEnum } from '../../../../../shared/open-layers/layer-filter.interface'
import { GeneralMapLayerDefinitionsContractGroupService } from './general-map-layer-definitions-contract-group.service'

@Injectable({
    providedIn: 'root'
})
export class GeneralMapLayerDefinitionsService {
    public CUZKATTRIBUTION = 'ČÚZK <a href="https://cuzk.gov.cz/" target="blank">https://cuzk.gov.cz</a>'

    // @ts-ignore
    private backendOptions = CA_CONFIG.BACKEND_OPTIONS

    constructor(
        @Inject(SelectedDepartmentService) protected selectedDepartmentService: SelectedDepartmentService,
        @Inject(DepartmentMapFilterService) protected departmentMapFilterService: DepartmentMapFilterService,
        @Inject(GeneralMapLayerDefinitionsConcernedService) protected generalMapLayerDefinitionsConcernedService: GeneralMapLayerDefinitionsConcernedService,
        @Inject(GeneralMapLayerDefinitionsDtsrcLpisService) protected generalMapLayerDefinitionsDtsrcLpisService: GeneralMapLayerDefinitionsDtsrcLpisService,
        @Inject(GeneralMapLayerDefinitionsParcelGroupService) protected generalMapLayerDefinitionsParcelGroupService: GeneralMapLayerDefinitionsParcelGroupService,
        @Inject(GeneralMapLayerDefinitionsContractGroupService) protected generalMapLayerDefinitionsContractGroupService: GeneralMapLayerDefinitionsContractGroupService,
        @Inject(MapColorGeneratorService) private mapColorGeneratorService: MapColorGeneratorService,
    ) {
    }

    public getLayerById(id, projectKey): any {
        switch (id) {
            case 'case-map-parcels':
                return this.getFeatureGroupCaseMapParcels()
            case 'barter-concerned-parcels':
                return this.getFeatureGroupBarterConcernedParcels()
            case 'barter-counterparty-parcels':
                return this.getFeatureGroupBarterCounterpartyParcels()
            case 'cuzk-orto':
                return this.getLayerCuzkOrtoConfig()
            case 'cuzk-kn':
                return this.getLayerCuzkKnConfig()
            case 'cuzk-pk':
                return this.getLayerCuzkPkConfig()
            case 'cuzk-zm10':
                return this.getLayerCuzkZtm()
            case 'farmer-blocks-foreign':
                return this.getLayerLpisFarmerBlocksForeign(projectKey)
            case 'farmer-blocks-own':
                return this.getLayerLpisFarmerBlocksOwn(projectKey)
            case 'all-farmer-blocks-own':
                return this.generalMapLayerDefinitionsDtsrcLpisService.getLayerAllLpisFarmerBlocksOwn()
            case 'all-farmer-blocks-foreign':
                return this.generalMapLayerDefinitionsDtsrcLpisService.getLayerAllLpisFarmerBlocksForeign()
            case 'katuze':
                return this.getLayerKatuze()
            case 'kraj':
                return this.getLayerKraj()
            case 'lpis-parcel-defect':
                return this.getLayerLpisParcelDefect(projectKey)
            case 'lpis-parcel-manage-possible':
                return this.getLayerLpisParcelManagePossible(projectKey)
            case 'lpis-parcel-manage-possible-outside-fb':
                return this.getLayerLpisParcelManagePossibleOutsideFb(projectKey)
            case 'lpis-parcel-missing-contract':
                return this.getLayerLpisParcelMissingContract(projectKey)
            case 'lpis-parcel-solved-foreign-fb':
                return this.getLayerLpisParcelSolvedForeignFb(projectKey)
            case 'lpis-parcel-solved-own-fb':
                return this.getLayerLpisParcelSolvedOwnFb(projectKey)
            case 'obec':
                return this.getLayerObec()
            case 'okres':
                return this.getLayerOkres()
            case 'parcely-castecne-vyuzivano':
                return this.getLayerParcelsCastecneVyuzivano(projectKey)
            case 'parcely-drupoz-chmelnice':
                return this.getLayerParcelsDrupozChmelnice(projectKey)
            case 'parcely-drupoz-lesnipozemek':
                return this.getLayerParcelsDrupozLesniPozemek(projectKey)
            case 'parcely-drupoz-neurceno':
                return this.getLayerParcelsDrupozNeurceno(projectKey)
            case 'parcely-drupoz-ornapuda':
                return this.getLayerParcelsDrupozOrnaPuda(projectKey)
            case 'parcely-drupoz-ostatniplocha':
                return this.getLayerParcelsDrupozOstatniPlocha(projectKey)
            case 'parcely-drupoz-ovocnysad':
                return this.getLayerParcelsDrupozOvocnySad(projectKey)
            case 'parcely-drupoz-travniporost':
                return this.getLayerParcelsDrupozTravniPorost(projectKey)
            case 'parcely-drupoz-vinice':
                return this.getLayerParcelsDrupozVinice(projectKey)
            case 'parcely-drupoz-vodniplocha':
                return this.getLayerParcelsDrupozVodniPlocha(projectKey)
            case 'parcely-drupoz-zahrada':
                return this.getLayerParcelsDrupozZahrada(projectKey)
            case 'parcely-drupoz-zastavenaplocha':
                return this.getLayerParcelsDrupozZastavenaPlocha(projectKey)
            case 'parcely-mam-v-najmu':
                return this.getLayerLegalUseMamVNajmu(projectKey)
            case 'parcely-na-koncicich-smlouvach':
                return this.getLayerParcelyNaKoncicichSmlouvach(projectKey)
            case 'parcely-nelze-propachtovavat':
                return this.getLayerParcelyNelzePropachtovavat(projectKey)
            case 'parcely-nepronajimam':
                return this.getLayerLegalUseNepronajimam(projectKey)
            case 'parcely-nerozhodnuto':
                return this.getLayerLegalUseNerozhodnuto(projectKey)
            case 'parcely-nutno-resit':
                return this.getLayerParcelsNutnoResit(projectKey)
            case 'parcely-neznami-vetsinovi-vlastnici':
                return this.getLayerParcelsNeznamiVetsinoviVlastnici(projectKey)
            case 'parcely-neznami-vlastnici':
                return this.getLayerParcelsNeznamiVlastnici(projectKey)
            case 'parcely-pronajimam':
                return this.getLayerLegalUsePronajimam(projectKey)
            case 'parcely-chybi-podpis':
                return this.getLayerParcelsChybiPodpis(projectKey)
            case 'parcely-ve-spoluvlastnictvi':
                return this.getLayerParcelsVeSpoluvlastnictvi(projectKey)
            case 'parcely-ve-vlastnictvi':
                return this.getLayerParcelsVeVlastnictvi(projectKey)
            case 'parcely-ve-vlastnim':
                return this.getLayerLegalUseVeVlastnim(projectKey)
            case 'parcely-v-reseni':
                return this.getLayerLegalUseVReseni(projectKey)
            case 'parcely-vsechny':
                return this.getLayerParcelsAllConfig(projectKey)
            case 'parcel-in-proposal':
                return this.getLayerParcelInProposal(projectKey)
            case 'building':
                return this.getLayerBuildingsAllConfig(projectKey)
            case 'territorial-labels':
                return this.getLayerTerritorialLabels()
            case 'use-barter-concerned':
                return this.getLayerUseBarterConcerned(projectKey)
            case 'use-barter-counterparty':
                return this.getLayerUseBarterCounterparty(projectKey)
            case 'use-contract-owner':
                return this.getLayerUseContractOwner(projectKey)
            case 'use-contract-tenant':
                return this.getLayerUseContractTenant(projectKey)
            case 'use-ownership':
                return this.getLayerUseOwnership(projectKey)
            case 'use-subcontract-owner':
                return this.getLayerUseSubcontractOwner(projectKey)
            case 'use-subcontract-tenant':
                return this.getLayerUseSubcontractTenant(projectKey)
            default:
                if (_.startsWith(id, 'parcel_concerned_')) {
                    const opsubId = parseInt(id.replace('parcel_concerned_', ''))
                    return this.generalMapLayerDefinitionsConcernedService.getConcernedLayer(opsubId,
                        this.getWmsProjectLayersUrlWithoutCache(), this.getProjectLayerPrefix(projectKey))
                } else if (_.startsWith(id, 'parcel_group_')) {
                    const parcelGroupId = parseInt(id.replace('parcel_group_', ''))
                    return this.generalMapLayerDefinitionsParcelGroupService.getParcelGroupLayer(
                        parcelGroupId,
                        this.getWmsProjectLayersUrlWithoutCache(),
                        this.getProjectLayerPrefix(projectKey))
                } else if (_.startsWith(id, 'contract_group_')) {
                    const contractGroupId = parseInt(id.replace('contract_group_', ''))
                    return this.generalMapLayerDefinitionsContractGroupService.getContractGroupLayer(
                        contractGroupId,
                        this.getWmsProjectLayersUrlWithoutCache(),
                        this.getProjectLayerPrefix(projectKey))
                } else {
                    return null
                }
        }
    }

    public getLayerCuzkOrtoConfig(): any {
        return {
            id: 'cuzk-orto',
            layer: {
                type: 'wmts',
                url: 'https://ags.cuzk.gov.cz/arcgis1/rest/services/ORTOFOTO/MapServer/tile/{TileMatrix}/{TileRow}/{TileCol}',
                requestEncoding: 'REST',
                attribution: this.CUZKATTRIBUTION,
                maxNativeZoom: 14,
                noWrap: true,
                unloadInvisibleTiles: true,
                zIndex: 20,
                wmts: {
                    layer: 'orto',
                    format: 'image/jpeg',
                    transparent: false,
                    tilematrixSet: 'default028mm',
                    style: 'default'
                }
            }
        }
    }

    public getLayerCuzkKnConfig(): any {
        return {
            id: 'cuzk-kn',
            layer: {
                type: 'wms',
                url: 'https://services.cuzk.gov.cz/wms/wms.asp?',
                wms: {
                    attribution: this.CUZKATTRIBUTION,
                    layers: 'KN',
                    format: 'image/png',
                    transparent: true,
                    noWrap: true,
                    unloadInvisibleTiles: true,
                    zIndex: 40
                }
            }
        }
    }

    public getLayerCuzkPkConfig(): any {
        return {
            id: 'cuzk-pk',
            layer: {
                type: 'wms',
                url: 'https://services.cuzk.gov.cz/wms/local-km-wms.asp?',
                wms: {
                    layers: 'RST_PK',
                    format: 'image/png',
                    transparent: true,
                    attribution: this.CUZKATTRIBUTION,
                    noWrap: true,
                    unloadInvisibleTiles: true,
                    zIndex: 50
                }
            }
        }
    }

    public getLayerCuzkZtm(): any {
        return {
            id: 'cuzk-zm10',
            layer: {
                type: 'wmts',
                url: 'https://ags.cuzk.gov.cz/arcgis1/rest/services/ZTM/MapServer/tile/{TileMatrix}/{TileRow}/{TileCol}',
                requestEncoding: 'REST',
                attribution: this.CUZKATTRIBUTION,
                maxNativeZoom: 13,
                unloadInvisibleTiles: true,
                zIndex: 10,
                noWrap: true,
                wmts: {
                    layer: 'zm',
                    format: 'image/png',
                    transparent: false,
                    tilematrixSet: 'default028mm',
                    style: 'default'
                }
            }
        }
    }

    public getLayerKatuze(): any {
        return {
            id: 'katuze',
            layer: {
                type: 'wms',
                url: this.getWmsAppLayersUrl(),
                wms: {
                    layers: this.getAppLayerPrefix() + 'katuze',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 87
                }
            }
        }
    }

    public getLayerKraj(): any {
        return {
            id: 'kraj',
            layer: {
                type: 'wms',
                url: this.getWmsAppLayersUrl(),
                wms: {
                    layers: this.getAppLayerPrefix() + 'kraj',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 79
                }
            }
        }
    }

    public getLayerParcelsDrupozChmelnice(projectKey): any {
        return {
            id: 'parcely-drupoz-chmelnice',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 310
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 3
                })
            }
        }
    }

    public getLayerParcelsDrupozLesniPozemek(projectKey): any {
        return {
            id: 'parcely-drupoz-lesnipozemek',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 360
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 10
                })
            }
        }
    }

    public getLayerParcelsDrupozNeurceno(projectKey): any {
        return {
            id: 'parcely-drupoz-neurceno',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 400
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsNull,
                    propertyName: 'drupoz_kod_real',
                })
            }
        }
    }

    public getLayerParcelsDrupozOrnaPuda(projectKey): any {
        return {
            id: 'parcely-drupoz-ornapuda',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 300
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 2
                })
            }
        }
    }

    public getLayerParcelsDrupozOstatniPlocha(projectKey): any {
        return {
            id: 'parcely-drupoz-ostatniplocha',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 390
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 14
                })
            }
        }
    }

    public getLayerParcelsDrupozOvocnySad(projectKey): any {
        return {
            id: 'parcely-drupoz-ovocnysad',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 340
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 6
                })
            }
        }
    }

    public getLayerParcelsDrupozTravniPorost(projectKey): any {
        return {
            id: 'parcely-drupoz-travniporost',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 350
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 7
                })
            }
        }
    }

    public getLayerParcelsDrupozVinice(projectKey): any {
        return {
            id: 'parcely-drupoz-vinice',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 320
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 4
                })
            }
        }
    }

    public getLayerParcelsDrupozVodniPlocha(projectKey): any {
        return {
            id: 'parcely-drupoz-vodniplocha',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 370
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 11
                })
            }
        }
    }

    public getLayerParcelsDrupozZahrada(projectKey): any {
        return {
            id: 'parcely-drupoz-zahrada',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 330
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 5
                })
            }
        }
    }

    public getLayerParcelsDrupozZastavenaPlocha(projectKey): any {
        return {
            id: 'parcely-drupoz-zastavenaplocha',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_drupoz',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 380
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'drupoz_kod_real',
                    literal: 13
                })
            }
        }
    }

    public getLayerLegalUseMamVNajmu(projectKey): any {
        const layer = {
            id: 'parcely-mam-v-najmu',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_legal_use_1',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 130
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerParcelyNaKoncicichSmlouvach(projectKey, expDate = null): any {
        const layer: any = {
            id: 'parcely-na-koncicich-smlouvach',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_ending_contract',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 410
                }
            }
        }

        if (expDate) {
            layer.layer.filter = this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                type: IFilterDefTypeEnum.PropertyIsLessThanOrEqualTo,
                propertyName: 'expiration_date',
                literal: expDate
            })
        } else {
            this.addDepartmentIdToEmptyLayerFilter(layer)
        }

        return layer
    }

    public getLayerParcelyNelzePropachtovavat(projectKey): any {
        const layer = {
            id: 'parcely-nelze-propachtovavat',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_no_further_rent',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 411
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerParcelInProposal(projectKey): any {
        const c = '#f7a928'
        const layer = {
            id: 'parcel-in-proposal',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_in_proposal',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 557
                },
                sldBody: {
                    name: this.getProjectLayerPrefix(projectKey) + 'parcel_in_proposal',
                    rules: [
                        {
                            name: 'parcel_in_proposal',
                            polygonSymbolizer: {
                                fill: {
                                    svgParameter: {
                                        'fill': c,
                                        'fill-opacity': 0.55
                                    }
                                },
                                stroke: {
                                    svgParameter: {
                                        'stroke': c,
                                        'stroke-width': 1
                                    }
                                }
                            }
                        }
                    ]
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.And,
                    args: [
                        {
                            type: IFilterDefTypeEnum.PropertyIsEqualTo,
                            propertyName: 'proposal_contract',
                            literal: true
                        }
                    ]
                })
            }
        }

        return layer
    }

    public getLayerLegalUseNepronajimam(projectKey): any {
        const layer = {
            id: 'parcely-nepronajimam',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_legal_use_6',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 90
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerLegalUseNerozhodnuto(projectKey): any {
        const layer = {
            id: 'parcely-nerozhodnuto',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_legal_use_3',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 100
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerLegalUsePronajimam(projectKey): any {
        const layer = {
            id: 'parcely-pronajimam',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_legal_use_5',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 120
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerParcelsVeSpoluvlastnictvi(projectKey): any {
        return {
            id: 'parcely-ve-spoluvlastnictvi',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_owner',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 210
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'only_in_my_ownership',
                    literal: false
                })
            }
        }
    }

    public getLayerParcelsVeVlastnictvi(projectKey): any {
        return {
            id: 'parcely-ve-vlastnictvi',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_owner',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 200
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'only_in_my_ownership',
                    literal: true
                })
            }
        }
    }

    public getLayerLegalUseVeVlastnim(projectKey): any {
        const layer = {
            id: 'parcely-ve-vlastnim',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_legal_use_4',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 110
                },
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerLegalUseVReseni(projectKey): any {
        const layer = {
            id: 'parcely-v-reseni',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_legal_use_7',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 125
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerLpisFarmerBlocksForeign(projectKey): any {
        return {
            id: 'farmer-blocks-foreign',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 60
                },
                filter: this.getLayerLpisFarmerBlocksForeignFilter(null)
            }
        }
    }

    public getLayerLpisFarmerBlocksForeignFilter(subject): any {
        let filter
        if (subject && subject.lpisId) {
            filter = {
                type: 'And',
                args: [
                    {
                        type: IFilterDefTypeEnum.PropertyIsEqualTo,
                        propertyName: 'concerned',
                        literal: false
                    },
                    {
                        type: IFilterDefTypeEnum.PropertyIsEqualTo,
                        propertyName: 'id_uz',
                        literal: subject.lpisId
                    }
                ]
            }
        } else {
            filter = {
                type: IFilterDefTypeEnum.PropertyIsEqualTo,
                propertyName: 'concerned',
                literal: false
            }
        }

        if (this.selectedDepartmentService.isDepartmentSelected()) {
            filter = {
                type: 'And',
                args: [
                    {
                        type: 'PropertyIsLike',
                        propertyName: 'department_id',
                        literal: '*|' + this.selectedDepartmentService.getSelectedDepartmentId() + '|*'
                    },
                    filter
                ]
            }
        }

        return filter
    }

    public getLayerLpisFarmerBlocksOwn(projectKey): any {
        const layer: any = {
            id: 'farmer-blocks-own',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 70
                },
                filter: {
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'concerned',
                    literal: true
                }
            }
        }

        if (this.selectedDepartmentService.isDepartmentSelected()) {
            layer.layer.filter = {
                type: IFilterDefTypeEnum.And,
                args: [
                    {
                        type: IFilterDefTypeEnum.PropertyIsLike,
                        propertyName: 'department_id',
                        literal: '*|' + this.selectedDepartmentService.getSelectedDepartmentId() + '|*'
                    },
                    layer.layer.filter
                ]
            }
        }

        return layer
    }

    public getLayerLpisParcelDefect(projectKey): any {
        return {
            id: 'lpis-parcel-defect',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis_parcel_claim_manage',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 540
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'claim_manage',
                    literal: 'defect'
                })
            }
        }
    }

    public getLayerLpisParcelManagePossible(projectKey): any {
        return {
            id: 'lpis-parcel-manage-possible',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis_parcel_claim_manage',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 520
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'claim_manage',
                    literal: 'manage_possible'
                })
            }
        }
    }

    public getLayerLpisParcelManagePossibleOutsideFb(projectKey): any {
        return {
            id: 'lpis-parcel-manage-possible-outside-fb',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis_parcel_claim_manage',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 525
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'claim_manage',
                    literal: 'manage_possible_outside_fb'
                })
            }
        }
    }

    public getLayerLpisParcelMissingContract(projectKey): any {
        return {
            id: 'lpis-parcel-missing-contract',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis_parcel_claim_manage',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 530
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'claim_manage',
                    literal: 'missing_contract'
                })
            }
        }
    }

    public getLayerLpisParcelSolvedForeignFb(projectKey): any {
        return {
            id: 'lpis-parcel-solved-foreign-fb',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis_parcel_claim_manage',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 510
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'claim_manage',
                    literal: 'solved_foreign_fb'
                })
            }
        }
    }

    public getLayerLpisParcelSolvedOwnFb(projectKey): any {
        return {
            id: 'lpis-parcel-solved-own-fb',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'lpis_parcel_claim_manage',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 500
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'claim_manage',
                    literal: 'solved_own_fb'
                })
            }
        }
    }

    public getLayerObec(): any {
        return {
            id: 'obec',
            layer: {
                type: 'wms',
                url: this.getWmsAppLayersUrl(),
                wms: {
                    layers: this.getAppLayerPrefix() + 'obec',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 85
                }
            }
        }
    }

    public getLayerOkres(): any {
        return {
            id: 'okres',
            layer: {
                type: 'wms',
                url: this.getWmsAppLayersUrl(),
                wms: {
                    layers: this.getAppLayerPrefix() + 'okres',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 82
                }
            }
        }
    }

    public getLayerParcelsAllConfig(projectKey): any {
        const layer = {
            id: 'parcely-vsechny',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_all',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 76
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerBuildingsAllConfig(projectKey): any {
        const layer = {
            id: 'building',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrl(),
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'building',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 75
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerParcelsCastecneVyuzivano(projectKey): any {
        return {
            id: 'parcely-castecne-vyuzivano',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_contract',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 160
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.And,
                    args: [
                        {
                            type: IFilterDefTypeEnum.PropertyIsEqualTo,
                            propertyName: 'type',
                            literal: '2'
                        },
                        {
                            type: IFilterDefTypeEnum.PropertyIsNull,
                            propertyName: 'type_valid'
                        },
                        {
                            type: IFilterDefTypeEnum.PropertyIsNull,
                            propertyName: 'end_date'
                        }
                    ]
                })
            }
        }
    }

    public getLayerParcelsNutnoResit(projectKey): any {
        return {
            id: 'parcely-nutno-resit',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_contract',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 140
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.And,
                    args: [
                        {
                            type: IFilterDefTypeEnum.PropertyIsEqualTo,
                            propertyName: 'type_valid',
                            literal: '1'
                        },
                        {
                            type: IFilterDefTypeEnum.PropertyIsEqualTo,
                            propertyName: 'valid_contract',
                            literal: true
                        }
                    ]
                })
            }
        }
    }

    public getLayerParcelsChybiPodpis(projectKey): any {
        return {
            id: 'parcely-chybi-podpis',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_contract_missing_signature',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 150
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.And,
                    args: [
                        {
                            type: IFilterDefTypeEnum.PropertyIsEqualTo,
                            propertyName: 'sent_for_signature',
                            literal: true
                        },
                        {
                            type: IFilterDefTypeEnum.PropertyIsNull,
                            propertyName: 'end_date'
                        }
                    ]
                })
            }
        }
    }

    public getLayerParcelsNeznamiVetsinoviVlastnici(projectKey): any {
        return {
            id: 'parcely-neznami-vetsinovi-vlastnici',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_unknown_majority_owners',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 180
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsGreaterThan,
                    propertyName: 'podil',
                    literal: '0.5'
                })
            }
        }
    }

    public getLayerParcelsNeznamiVlastnici(projectKey): any {
        const layer = {
            id: 'parcely-neznami-vlastnici',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'parcel_unknown_owners',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 170
                }
            }
        }

        this.addDepartmentIdToEmptyLayerFilter(layer)

        return layer
    }

    public getLayerTerritorialLabels(): any {
        return {
            id: 'territorial-labels',
            layer: {
                type: 'wms',
                url: this.getWmsAppLayersUrl(),
                wms: {
                    layers: this.getAppLayerPrefix() + 'territorial_labels',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 88
                }
            }
        }
    }

    public getLayerUseBarterConcerned(projectKey): any {
        return {
            id: 'use-barter-concerned',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_barter_concerned',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 550
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_barter_concerned',
                    literal: 'true'
                })
            }
        }
    }

    public getLayerUseBarterCounterparty(projectKey): any {
        return {
            id: 'use-barter-counterparty',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_barter_counterparty',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 551
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_barter_counterparty',
                    literal: 'true'
                })
            }
        }
    }

    public getLayerUseContractOwner(projectKey): any {
        return {
            id: 'use-contract-owner',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_contract_owner',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 552
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_contract_owner',
                    literal: 'true'
                })
            }
        }
    }

    public getLayerUseContractTenant(projectKey): any {
        return {
            id: 'use-contract-tenant',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_contract_tenant',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 553
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_contract_tenant',
                    literal: 'true'
                })
            }
        }
    }

    public getLayerUseSubcontractOwner(projectKey): any {
        return {
            id: 'use-subcontract-owner',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_subcontract_owner',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 554
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_subcontract_owner',
                    literal: 'true'
                })
            }
        }
    }

    public getLayerUseSubcontractTenant(projectKey): any {
        return {
            id: 'use-subcontract-tenant',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_subcontract_tenant',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 555
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_subcontract_tenant',
                    literal: 'true'
                })
            }
        }
    }

    public getLayerUseOwnership(projectKey): any {
        return {
            id: 'use-ownership',
            layer: {
                type: 'wms',
                url: this.getWmsProjectLayersUrlWithoutCache(),
                reload: true,
                wms: {
                    layers: this.getProjectLayerPrefix(projectKey) + 'par_lpis_by_contracts_ownership',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 556
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'use_ownership',
                    literal: 'true'
                })
            }
        }
    }

    public getFeatureGroupBarterConcernedParcels(): any {
        return {
            id: 'barter-concerned-parcels',
            layer: {
                type: 'featureGroup'
            }
        }
    }

    public getFeatureGroupBarterCounterpartyParcels(): any {
        return {
            id: 'barter-counterparty-parcels',
            layer: {
                type: 'featureGroup'
            }
        }
    }

    public getFeatureGroupCaseMapParcels(): any {
        return {
            id: 'case-map-parcels',
            layer: {
                type: 'featureGroup'
            }
        }
    }

    //////////////////////////////////////////////////////////////////////////

    private addDepartmentIdToEmptyLayerFilter(layer): any {
        if (this.selectedDepartmentService.isDepartmentSelected()) {
            const filter = this.departmentMapFilterService.updateMapFilterDepartmentIdEqual(null)

            if (filter) {
                layer.layer.filter = filter
            }
        }
    }

    private getAppLayerPrefix(): string {
        return 'dtsrc_ruian:dtsrc_ruian_dtsrc_ruian_'
    }

    private getProjectLayerPrefix(projectKey): string {
        return 'assets:assets_' + projectKey + '_'
    }

    private getWmsAppLayersUrl(): string {
        return this.backendOptions.geoserverAppUrl + '/gwc/service/wms'
    }

    private getWmsProjectLayersUrl(): string {
        return this.selectedDepartmentService.isDepartmentSelected()
            ? this.getWmsProjectLayersUrlWithoutCache()
            : this.getWmsProjectLayersUrlWithCache()
    }

    private getWmsProjectLayersUrlWithCache(): string {
        return this.backendOptions.geoserverProjectUrl + '/gwc/service/wms'
    }

    private getWmsProjectLayersUrlWithoutCache(): string {
        return this.backendOptions.geoserverProjectUrl + '/wms'
    }
}
